import React from 'react';
import PropTypes from 'prop-types';

import FormList from 'core/components/form-list';
import Trailer from './trailer';
import AddTrailer from './add-trailer';

const Trailers = ({ disabled, ...rest }) => {
  return (
    <FormList
      disabled={disabled}
      id="trailers"
      item={Trailer}
      addForm={AddTrailer}
      title="Trailers"
      singular="trailer"
      plural="trailers"
      {...rest}
    />
  );
};

Trailers.propTypes = {
  disabled: PropTypes.bool
};

Trailers.defaultProps = {
  disabled: false
};

export default Trailers;
